import { Schema, normalize, arrayOf } from 'normalizr'
import { camelizeKeys } from '@utils/object.js'
import { remapNormalized } from '@utils/entities.js'
import { receiveEntities } from '@actions/entity_actions.js'
import Types from '../types.js'

export const handleLoadTimelinesSuccess = (response, pageNumber, groupId) => {
  return dispatch => {
    const parsedJSON = response.data
    const gridItemSchema = new Schema('grid_items')
    const timelineSchema = new Schema('timelines')
    const photoSchema = new Schema('photos')
    const categorySchema = new Schema('categories')
    timelineSchema.define({
      photos: arrayOf(photoSchema),
      categories: arrayOf(categorySchema),
    })
    gridItemSchema.define({ timeline: timelineSchema })

    const normalized = remapNormalized(
      normalize(parsedJSON, {
        grid_items: arrayOf(gridItemSchema),
      })
    )

    dispatch(receiveEntities(normalized.entities))

    const { currentPage, limitValue, totalCount } = camelizeKeys(normalized.result.meta.pagination)
    const payload = {
      groupId,
      pageNumber,
      ids: normalized.result.grid_items,
      pagination: { currentPage, limitValue, totalCount },
    }

    dispatch({
      type: Types.TIMELINES_SUCCESS,
      payload,
    })
  }
}

export const handleLoadTimelinesError = (err, pageNumber, groupId) => ({
  type: Types.TIMELINES_FAILURE,
  payload: {
    groupId,
    pageNumber,
  },
})

export default {
  handleLoadTimelinesSuccess,
  handleLoadTimelinesError,
}
